import { VertiNodeLocale, type VertiNodeLocalizedString } from "../VertiNodeLocale.js";

export const vertiNodeAboutPathMap = {
	[VertiNodeLocale.cs]: "o-vertinode-aplikaci",
	[VertiNodeLocale.en]: "about-vertinode-app",
} satisfies VertiNodeLocalizedString;
